import { contactData } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[800px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500/10 border border-primary-500/20 text-xs font-medium text-primary-400 mb-3">
            <i className="ri-mail-send-line"></i>
            期待来信
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">联系投稿</h2>
          <p className="mt-2 text-sm text-foreground-500">{contactData.intro}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
          <div className="p-5 rounded-2xl bg-background-100 border border-background-200/60 text-center">
            <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-2xl bg-primary-500/10 mb-3">
              <i className="ri-mail-line text-xl text-primary-400"></i>
            </div>
            <div className="text-xs text-foreground-500 mb-1">电子邮箱</div>
            <div className="text-sm font-semibold text-foreground-800">{contactData.email}</div>
          </div>
          <div className="p-5 rounded-2xl bg-background-100 border border-background-200/60 text-center">
            <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-2xl bg-accent-500/10 mb-3">
              <i className="ri-wechat-line text-xl text-accent-400"></i>
            </div>
            <div className="text-xs text-foreground-500 mb-1">微信公众号</div>
            <div className="text-sm font-semibold text-foreground-800">{contactData.wechat}</div>
          </div>
          <div className="p-5 rounded-2xl bg-background-100 border border-background-200/60 text-center">
            <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-2xl bg-secondary-500/10 mb-3">
              <i className="ri-qq-line text-xl text-secondary-400"></i>
            </div>
            <div className="text-xs text-foreground-500 mb-1">QQ群号</div>
            <div className="text-sm font-semibold text-foreground-800">{contactData.qq}</div>
          </div>
        </div>

        <div className="rounded-2xl bg-background-100 border border-background-200/60 p-6 md:p-8">
          <div className="text-center text-sm text-foreground-500">
            欢迎优秀的内容创作者和影视爱好者与我们建立联系。无论是内容投稿、合作建议还是使用问题，我们都会认真对待每一条信息，期待你的来信。
          </div>
        </div>
      </div>
    </section>
  );
}